/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

import './App.css';

import IframeWrapper from './components/IframeWrapper';
// local imports
import HomeOld from './components/general/Home-old';
import Home from './components/general/Home';
// import AboutUs from './components/general/AboutUs';
import ContactUs from './components/general/ContactUs';
import Feedback from './components/general/Feedback';
import RSSFeed from './components/general/RSSFeed';
// import PrivacyPolicy from './components/general/PrivacyPolicy';
// import TermsConditions from './components/general/TermsConditions';
// import CookiePolicy from './components/general/CookiePolicy';
// import Sitemap from './components/general/Sitemap';
import FAQ from './components/general/FAQ';
import Offline from './components/general/OfflineFallback';
import ReleaseNotes from './components/general/ReleaseNotes';
import UnderMaintenance from './components/general/UnderMaintenance';
import ErrorFallback from './components/general/ErrorFallback';
import ErrorReport from './components/general/ErrorReport';
import Services from './components/general/Services';
import Service from './components/general/Service';
import ServiceRequest from './components/general/ServiceRequest';
import BookSessionQuestionaire from './components/general/BookSessionQuestionaire';

import SignIn from './components/user/SignIn';
import SignUp from './components/user/SignUp';
import ForgotPassword from './components/user/ForgotPassword';
import ResetPassword from './components/user/ResetPassword';
import UserVerification from './components/user/UserVerifiction';
// import ProviderPublicPage from './components/user/ProviderPublicPage';

import AdminDashboard from './components/admin/AdminDashboard';

import ClientDashboard from './components/client/ClientDashboard';
import BookSession from './components/client/BookSession';
import MakePayment from './components/client/MakePayment';
import ClientProfile from './components/client/ClientProfile';
// import ProviderList from './components/client/ProviderList';
import Form from './components/client/Form';
import ClientSettings from './components/client/Settings';
import ViewClientProfile from './components/client/ViewClientProfile';
import ClientChat from './components/client/ClientChat';
import ClientSubscription from './components/client/Subscriptions';
import ClientSubscriptionPayment from './components/client/MakeSubscriptionPayment';
import UpdateClientSubscription from './components/client/UpdateSubscription';
import CancelClientSubscription from './components/client/CancelSubscription';

import ProviderProfile from './components/provider/ProviderProfile';
import AvailableTimingsAndDays from './components/provider/AvailableTimingsAndDays';
import MyPricing from './components/provider/MyPricing';
import MyClients from './components/provider/MyClients';
import ClientFormResponse from './components/provider/ClientFormResponse';
import Sessions from './components/provider/Sessions';
import Payments from './components/provider/Payments';
import StartMeet from './components/provider/StartMeet';
import ProviderSettings from './components/provider/Settings';
import ViewProviderProfile from './components/provider/ViewProviderProfile';
import ProviderChat from './components/provider/ProviderChat';
import ReserveSession from './components/provider/ReserveSession';
import ConfirmSession from './components/provider/ConfirmSession';
import ClientSubscriptions from './components/provider/ClientSubscriptions';
import ClientSubscriptionDetail from './components/provider/ClientSubscriptionDetail';
import SelectProviderSubscriptionPlan from './components/provider/SelectProviderSubscriptionPlan';
import ProviderSubscriptionMakePayment from './components/provider/ProviderSubscriptionMakePayment';
import ProviderSubscription from './components/provider/ProviderSubscription';
import ProviderSubscriptionDetails from './components/provider/ProviderSubscriptionDetails';
import UpdateProviderSubscription from './components/provider/UpdateProviderSubscription';
import CancelProviderSubscription from './components/provider/CancelProviderSubscription';
// import UnclaimedProviderProfile from './components/provider/UnclaimedProviderProfile';
import ClaimProfileStep1 from './components/provider/ClaimProfileStep1';
import ClaimProfileStep2 from './components/provider/ClaimProfileStep2';
import ProviderSubscriptionPricing from './components/provider/ProviderSubscriptionPricing';

import DemoSignIn from './components/demo/SignIn';
import RequestDemo from './components/demo/RequestDemo';

import DemoClientDashboard from './components/demo/client/ClientDashboard';
import DemoViewClientProfile from './components/demo/client/ViewClientProfile';
import DemoClientProfile from './components/demo/client/ClientProfile';
import DemoBookSession from './components/demo/client/BookSession';
import DemoMakePayment from './components/demo/client/MakePayment';
import DemoForm from './components/demo/client/Form';
import DemoClientSettings from './components/demo/client/Settings';
import DemoClientChat from './components/demo/client/ClientChat';
import DemoClientSubscription from './components/demo/client/Subscriptions';
import DemoClientSubscriptionPayment from './components/demo/client/MakeSubscriptionPayment';
import DemoUpdateClientSubscription from './components/demo/client/UpdateSubscription';
import DemoCancelClientSubscription from './components/demo/client/CancelSubscription';

// import DemoProviderList from './components/demo/client/ProviderList';
import DemoProviderSessions from './components/demo/provider/Sessions';
import DemoProviderProfile from './components/demo/provider/ProviderProfile';
import DemoAvailableTimingsAndDays from './components/demo/provider/AvailableTimingsAndDays';
import DemoMyPricing from './components/demo/provider/MyPricing';
import DemoMyClients from './components/demo/provider/MyClients';
import DemoPayments from './components/demo/provider/Payments';
import DemoStartMeet from './components/demo/provider/StartMeet';
import DemoClientFormResponse from './components/demo/provider/ClientFormResponse';
import DemoProviderSettings from './components/demo/provider/Settings';
import DemoViewProviderProfile from './components/demo/provider/ViewProviderProfile';
import DemoProviderChat from './components/demo/provider/ProviderChat';
import DemoReserveSession from './components/demo/provider/ReserveSession';
import DemoConfirmSession from './components/demo/provider/ConfirmSession';
import DemoClientSubscriptions from './components/demo/provider/ClientSubscriptions';
import DemoClientSubscriptionDetail from './components/demo/provider/ClientSubscriptionDetail';
// import DemoSelectProviderSubscriptionPlan from './components/demo/provider/SelectProviderSubscriptionPlan';
import DemoProviderSubscriptionMakePayment from './components/demo/provider/ProviderSubscriptionMakePayment';
import DemoProviderSubscription from './components/demo/provider/ProviderSubscription';
import DemoProviderSubscriptionDetails from './components/demo/provider/ProviderSubscriptionDetails';
import DemoUpdateProviderSubscription from './components/demo/provider/UpdateProviderSubscription';
import DemoCancelProviderSubscription from './components/demo/provider/CancelProviderSubscription';
// import DemoUnclaimedProviderProfile from './components/demo/provider/UnclaimedProviderProfile';
// import DemoProviderInfo1 from './components/demo/provider/ProviderInfo1';

import UserSignUpLandingScreen from './components/user/UserSignUpLandingScreen';

// import OrganisationLandingScreen from './components/organisation/OrganisationLandingScreen';
// import OrganisationSignUpStep1 from './components/organisation/OrganisationSignUpStep1';
// import OrganisationSignUpStep2 from './components/organisation/OrganisationSignUpStep2';
// import OrganisationSignUpStep3 from './components/organisation/OrganisationSignUpStep3';
// import OrganisationDashboard from './components/organisation/OrganisationDashboard';
// import OrganisationSubscription from './components/organisation/OrganisationSubscription';
// import OrganisationSubscriptionMakePayment from './components/organisation/OrganisationSubscriptionMakePayment';

import ProviderLandingScreen from './components/provider/ProviderLandingScreen';
import ProviderSignUpStep1 from './components/provider/ProviderSignUpStep1';
import ProviderSignUpStep2 from './components/provider/ProviderSignUpStep2';

import ClientLandingScreen from './components/client/ClientLandingScreen';
import ClientSignUpStep1 from './components/client/ClientSignUpStep1';
import ClientSignUpStep2 from './components/client/ClientSignUpStep2';

import ProviderForm from './components/general/ProviderForm';
// import ProviderFeatures from './components/general/ProviderFeatures';
// import ProviderBenefits from './components/general/ProviderBenefits';

import PsychometricTestLandingPage from './components/psychometric/PsychometricTestLandingPage';
import PsychometricPDFReport from './components/psychometric/PsychometricPDFReport';
import PsychometricTestTakerPortal from './components/psychometric/PsychometricTestTakerPortal';
import PsychometricManagementPortal from './components/psychometric/PsychometricManagementPortal';
import PsychometricTestWrapper from './components/psychometric/PsychometricTestWrapper'
import PyschometricIndividualHomePage from './components/psychometric/PsychometricIndividualHomePage';
import PsychometricOrganizationSignUp from './components/psychometric/PyschometricOrganizationSignUp';
import PsychometricIndividualSignUp from './components/psychometric/PsychometricIndividualSignUp';
import PyschometricOrganizationHomePage from './components/psychometric/PyschometricOrganizationHomePage';
import PsychometricOrganizationCandidateControl from './components/psychometric/PyschometricOrganizationCandidateControl';
import NetworkDetector from './hocs/NetworkDetector';
import PrivateRoute from './hocs/PrivateRoute';
import UnPrivateRoute from './hocs/UnPrivateRoute';

import { AuthContext } from './contexts/AuthContext';

import axios from 'axios';

import PsychometricOrganizationTestTakerPortal from './components/psychometric/PsychometricOrganizationTestTakerPortal';
import PsychometricIndividualTestTakerPortal from './components/psychometric/PsychometricIndividualTestTakerPortal';

import PsychometricForgotPassword from './components/psychometric/PsychometricForgotPassword';

import PsychometricCookiePolicy from './components/psychometric/PsychometricCookiePolicy';
import PsychometricTermsConditions from './components/psychometric/PsychometricTermsConditions';
import PsychometricPrivacyPolicy from './components/psychometric/PsychometricPrivacyPolicy';

import PsychometricTestAbout from './components/psychometric/PsychometricTestAbout';

// axios interceptor for logout on unauthorized access
axios.interceptors.response.use(response => {
  return response;
}, error => {
  // console.log('interceptor error ->>>> ', error);
  if (error.response.status === 401) {
    console.log("error 401");
    // const { setUser, setIsAuthenticated } = useContext(AuthContext);
    // setUser({ username: "", email: "", profileImage: "", timezone: "", selectedRole: "", roles: [], guideTakenFor: [], isApproved: false });
    // setIsAuthenticated(false);
  }
  return Promise.reject(error);
});

const App = () => {

  const { maintenance } = useContext(AuthContext);

  const NotFoundRedirect = (data) => {
    // if(!data.location.pathname.startsWith("/counsellors"))
      return <Redirect to='/' />
  }

  const MaintenanceRedirect = () => <Redirect to='/maintenance' />

  useEffect(() => {
    let root = document.getElementById('root');
    if (root && !root.classList.contains('container') && !document.location.pathname.includes('/chat')) {
      root.classList.add('container');
    }
  }, [])

  return (
    <Router>
      <Alert timeout={4000} stack={{ limit: 5 }} />

      {/* {loader} */}
      {
        maintenance.status && (moment().isBetween(moment(maintenance.startAt), (moment(maintenance.startAt).add(maintenance.duration, 'minutes')))) ?
          // maintenance.status ?
          <Switch>
            <UnPrivateRoute path="/user/signin" component={SignIn} />
            <PrivateRoute path="/admin/dashboard" roles={["admin"]} component={AdminDashboard} />
            {/* <Route path="/admin/dashboard" component={AdminDashboard} /> */}
            <Route path="/maintenance" component={UnderMaintenance} />
            <Route component={MaintenanceRedirect} />
          </Switch>
          :
          <Switch>
           {/* <Route exact path="/" component={Home} /> */}
            <Route path="/booksessionQuestionaire" component={BookSessionQuestionaire} />
            <Route path="/oldHome" component={HomeOld} />
            {/* <Route path="/aboutus" component={AboutUs} /> */}
            <Route path='/contact' component={ContactUs} /> 
            <Route path='/feedback' component={Feedback} />
            {/* <Route path="/privacypolicy" component={PrivacyPolicy} /> */}
            {/* <Route path="/termsconditions" component={TermsConditions} /> */}
            {/* <Route path="/cookiepolicy" component={CookiePolicy} /> */}
            {/* <Route path="/sitemap" component={Sitemap} /> */}
            <Route path="/faq" component={FAQ} />
            <Route path="/dailyfeed" component={RSSFeed} />
            <Route path="/offline" component={Offline} />
            <Route path="/releasenotes" component={ReleaseNotes} />
            <Route path="/error" component={ErrorFallback} />
            <Route path="/errorReport" component={ErrorReport} />
            <Route path="/services" component={Services} />
            <Route path="/service" component={Service} />
            <Route path="/serviceRequest" component={ServiceRequest} />
            <Route path="/counsellorForm/:id" component={ProviderForm} />

            <Route path="/demo/signin" component={DemoSignIn} />
            <Route path="/demo/signupRequest" component={RequestDemo} />

            <Route path="/demo/client/dashboard" component={DemoClientDashboard} />
            <Route path="/demo/client/booksession" component={DemoBookSession} />
            <Route path="/demo/client/makepayment" component={DemoMakePayment} />
            <Route exact path="/demo/client/profile" component={DemoViewClientProfile} />
            <Route exact path="/demo/client/profile/edit" component={DemoClientProfile} />
            <Route path="/demo/client/chat" component={DemoClientChat} />
            <Route path="/demo/client/form" component={DemoForm} />
            <Route path="/demo/client/settings" component={DemoClientSettings} />
            <Route path="/demo/client/subscription" component={DemoClientSubscription} />
            <Route path="/demo/client/updateSubscription" component={DemoUpdateClientSubscription} />
            <Route path="/demo/client/makesubscriptionpayment" component={DemoClientSubscriptionPayment} />
            <Route path="/demo/client/cancelSubscription" component={DemoCancelClientSubscription} />
            {/* <Route path="/demo/counsellorList" component={DemoProviderList} /> */}

            <Route path="/demo/counsellor/sessions" component={DemoProviderSessions} />
            <Route exact path="/demo/counsellor/profile" component={DemoViewProviderProfile} />
            <Route exact path="/demo/counsellor/profile/edit" component={DemoProviderProfile} />
            <Route path="/demo/counsellor/availabledaytime" component={DemoAvailableTimingsAndDays} />
            <Route path="/demo/counsellor/pricing" component={DemoMyPricing} />
            <Route path="/demo/counsellor/clients" component={DemoMyClients} />
            <Route path="/demo/counsellor/clientFormResponse" component={DemoClientFormResponse} />
            <Route path="/demo/counsellor/settings" component={DemoProviderSettings} />
            <Route path="/demo/counsellor/meet" component={DemoStartMeet} />
            <Route path="/demo/counsellor/reservesession" component={DemoReserveSession} />
            <Route path="/demo/counsellor/confirmsession" component={DemoConfirmSession} />
            <Route path="/demo/counsellor/payments" component={DemoPayments} />
            <Route path="/demo/counsellor/chat" component={DemoProviderChat} />
            <Route path="/demo/counsellor/clientsubscription" component={DemoClientSubscriptions} />
            <Route path="/demo/counsellor/clientsubscriptiodetail" component={DemoClientSubscriptionDetail} />
            <Route path="/demo/counsellor/subscription" component={DemoProviderSubscription} />
            <Route path="/demo/counsellor/subscription/details" component={DemoProviderSubscriptionDetails} />
            <Route path="/demo/counsellor/updateSubscription" component={DemoUpdateProviderSubscription} />
            <Route path="/demo/counsellor/cancelSubscription" component={DemoCancelProviderSubscription} />
            <Route path="/demo/counsellor/makesubscriptionpayment" component={DemoProviderSubscriptionMakePayment} />
            {/*
            <Route path="/demo/counsellor/subscriptionplans" component={DemoSelectProviderSubscriptionPlan} />
            <Route path="/demo/counsellor/ProviderInfo1" component={DemoProviderInfo1} />
          */}

            <UnPrivateRoute path="/user/forgotpassword" component={ForgotPassword} />
            <UnPrivateRoute path="/user/signin" component={SignIn} />
            <UnPrivateRoute path="/user/signup" component={SignUp} />
            <UnPrivateRoute path="/user/resetpassword/:token" component={ResetPassword} />
            <UnPrivateRoute path="/user/verify/:type/:token" component={UserVerification} />

            <PrivateRoute path="/client/profile/edit" roles={["client"]} component={ClientProfile} />
            <PrivateRoute path="/client/profile" roles={["client"]} component={ViewClientProfile} />
            {/* <PrivateRoute path="/client/counsellorlist" roles={["client"]} component={ProviderList} /> */}
            <PrivateRoute path="/client/dashboard" roles={["client"]} component={ClientDashboard} />
            <PrivateRoute path="/client/booksession" roles={["client"]} component={BookSession} />
            <PrivateRoute path="/client/makepayment" roles={["client"]} component={MakePayment} />
            <PrivateRoute path="/client/form" roles={["client"]} component={Form} />
            <PrivateRoute path="/client/settings" roles={["client"]} component={ClientSettings} />
            <PrivateRoute path="/client/chat" roles={["client"]} component={ClientChat} />
            <PrivateRoute path="/client/subscription" roles={["client"]} component={ClientSubscription} />
            <PrivateRoute path="/client/makesubscriptionpayment" roles={["client"]} component={ClientSubscriptionPayment} />
            <PrivateRoute path="/client/updateSubscription" roles={["client"]} component={UpdateClientSubscription} />
            <PrivateRoute path="/client/cancelSubscription" roles={["client"]} component={CancelClientSubscription} />

            {/* <Route exact path="/counsellors" component={ProviderList} />
            <Route exact path="/counsellors/:providerUniqueId" component={ProviderPublicPage} />
            <Route path="/counsellors/unclaimedProfile/:providerUniqueId" component={UnclaimedProviderProfile} /> */}

            {/* <Route path="/counsellors/benefits" component={ProviderBenefits} /> */}
            {/* <Route path="/counsellors/features" component={ProviderFeatures} /> */}
            <Route path="/counsellor/claimProfileStep1" component={ClaimProfileStep1} />
            <Route path="/counsellor/claimProfileStep2" component={ClaimProfileStep2} />

            <PrivateRoute path="/counsellor/profile/edit" roles={["provider"]} component={ProviderProfile} />
            <PrivateRoute path="/counsellor/profile" roles={["provider"]} component={ViewProviderProfile} />
            <PrivateRoute path="/counsellor/availabledaytime" roles={["provider"]} component={AvailableTimingsAndDays} />
            <PrivateRoute path="/counsellor/mypricing" roles={["provider"]} component={MyPricing} />
            <PrivateRoute path="/counsellor/clients" roles={["provider"]} component={MyClients} />
            <PrivateRoute path="/counsellor/clientFormResponse" roles={["provider"]} component={ClientFormResponse} />
            <PrivateRoute path="/counsellor/sessions" roles={["provider"]} component={Sessions} />
            <PrivateRoute path="/counsellor/payments" roles={["provider"]} component={Payments} />
            <PrivateRoute path="/counsellor/settings" roles={["provider"]} component={ProviderSettings} />
            <PrivateRoute path="/counsellor/meet" roles={["provider"]} component={StartMeet} />
            <PrivateRoute path="/counsellor/reservesession" roles={["provider"]} component={ReserveSession} />
            <PrivateRoute path="/counsellor/confirmsession" roles={["provider"]} component={ConfirmSession} />
            <PrivateRoute path="/counsellor/chat" roles={["provider"]} component={ProviderChat} />
            <PrivateRoute path="/counsellor/clientsubscription" roles={["provider"]} component={ClientSubscriptions} />
            <PrivateRoute path="/counsellor/clientsubscriptiodetail" roles={["provider"]} component={ClientSubscriptionDetail} />
            <PrivateRoute path="/counsellor/subscriptionplans" roles={["provider"]} component={SelectProviderSubscriptionPlan} />
            <PrivateRoute path="/counsellor/subscription/details" roles={["provider"]} component={ProviderSubscriptionDetails} />
            <PrivateRoute path="/counsellor/subscription" roles={["provider"]} component={ProviderSubscription} />
            <PrivateRoute path="/counsellor/makesubscriptionpayment" roles={["provider"]} component={ProviderSubscriptionMakePayment} />
            <PrivateRoute path="/counsellor/updateSubscription" roles={["provider"]} component={UpdateProviderSubscription} />
            <PrivateRoute path="/counsellor/cancelSubscription" roles={["provider"]} component={CancelProviderSubscription} />

            <PrivateRoute path="/user/landingScreen" roles={['', 'client', 'provider', 'organisation_admin', 'admin']} component={UserSignUpLandingScreen} />

            <PrivateRoute path="/client/landingScreen" roles={['', 'provider', 'organisation_admin', 'admin']} component={ClientLandingScreen} />
            <PrivateRoute path="/client/signup-step1" roles={['', 'provider', 'organisation_admin', 'admin']} component={ClientSignUpStep1} />
            <PrivateRoute path="/client/signup-step2" roles={['', 'provider', 'organisation_admin', 'admin']} component={ClientSignUpStep2} />

            <PrivateRoute path="/counsellor/landingScreen" roles={['', 'client', 'organisation_admin', 'admin']} component={ProviderLandingScreen} />
            <Route path="/counsellor/pricing" component={ProviderSubscriptionPricing} />
            <PrivateRoute path="/counsellor/signup-step1" roles={['', 'client', 'organisation_admin', 'admin']} component={ProviderSignUpStep1} />
            <PrivateRoute path="/counsellor/signup-step2" roles={['', 'client', 'organisation_admin', 'admin']} component={ProviderSignUpStep2} />

            {/* <Route path="/organisation/landingScreen" roles={['', 'client', 'provider', 'admin']} component={OrganisationLandingScreen} />
            <Route path="/organisation/signup-step1" roles={['', 'client', 'provider', 'admin']} component={OrganisationSignUpStep1} />
            <Route path="/organisation/signup-step2" roles={['', 'client', 'provider', 'admin']} component={OrganisationSignUpStep2} />
            <Route path="/organisation/signup-step3" roles={['', 'client', 'provider', 'admin']} component={OrganisationSignUpStep3} />

            <Route path="/organisation/dashboard" roles={['organisation_admin']} component={OrganisationDashboard} />
            <Route path="/organisation/subscription" roles={['organisation_admin']} component={OrganisationSubscription} />
            <Route path="/organisation/makesubscriptionpayment" roles={['organisation_admin']} component={OrganisationSubscriptionMakePayment} /> */}
             <Route path="/psychometricPDF" component={PsychometricPDFReport} />
             <Route exact path="/" component={PsychometricTestLandingPage} />
             <Route path="/psychometricTestTakerPortal" component={PsychometricTestTakerPortal} />
            
             <Route path="/psychometricManagementPortal" component={PsychometricManagementPortal} />
             <Route 
              path="/psychometrictest/:param1/:param2?/:param3?/:param4?" 
              render={(props) => (
                <PsychometricTestWrapper 
                  useIframe={props.location.search.includes('iframe=true')} 
                  {...props} 
                />
              )} 
            />
            <Route path="/psychometricIndividualHome" component={PyschometricIndividualHomePage} />
             <Route path="/psychometricOrganizationCandidates" component={PsychometricOrganizationCandidateControl} />
             <Route path="/psychometricOrganizationHome" component={PyschometricOrganizationHomePage} />
             <Route path="/psychometricIndividualSignUp" component={PsychometricIndividualSignUp} />
             <Route path="/psychometricOrgSignUp" component={PsychometricOrganizationSignUp} />
            <PrivateRoute path="/admin/dashboard" roles={["admin"]} component={AdminDashboard} />
            {/* <Route path="/admin/dashboard" component={AdminDashboard} /> */}

            <Route path="/psychometricOrganizationTestTakerPortal" component={PsychometricOrganizationTestTakerPortal} />
            <Route path="/psychometricIndividualTestTakerPortal" component={PsychometricIndividualTestTakerPortal} />

            <Route path="/psychometricForgotPassword" component={PsychometricForgotPassword} />

            <Route 
                exact 
                path="/cookiepolicy" 
                component={PsychometricCookiePolicy} 
            />
            <Route 
                exact 
                path="/termsconditions" 
                component={PsychometricTermsConditions} 
            />
            <Route 
                exact 
                path="/privacypolicy" 
                component={PsychometricPrivacyPolicy} 
            />

            <Route path="/psychometricAbout" component={PsychometricTestAbout} />

            {/* tests */}
            <Route component={NotFoundRedirect} />

          </Switch>
      }
    </Router>
  );
}

export default NetworkDetector(App);